/*@flow*/
import * as I from 'immutable';

export default function mkPoint(
  ll: I.Map<string, any> | { lat: number, lon: number }
): string {
  if (!ll) return '';
  ll = I.fromJS(ll);
  const { lat, lon: lng } = ll.toJS();
  if (!lat || !lng) return '';
  return `POINT (${lng} ${lat})`;
}
